"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.textStyles = exports.heroTitleSize = exports.pageTitleSize = exports.bodySize = void 0;

var _colors = _interopRequireDefault(require("./colors"));

var _space = _interopRequireDefault(require("./space")); // Calculating the fluid font styles


var fluidFont = function fluidFont(min, max) {
  var minVw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 57.6;
  var maxVw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 99.2;
  return "calc(".concat(min, "rem + (").concat(max, " - ").concat(min, ") * ((100vw - ").concat(minVw, "rem) / (").concat(maxVw, " - ").concat(minVw, ")) )");
};

var bodySize = {
  xxlarge: {
    fontSize: ['2.0rem', null, '2.8rem'],
    lineHeight: ['3.2rem', null, '3.8rem'],
    fontWeight: 'normal'
  },
  xlarge: {
    fontSize: '2.4rem',
    lineHeight: '3.2rem',
    fontWeight: 'normal'
  },
  large: {
    fontSize: '2rem',
    lineHeight: '2.8rem',
    fontWeight: 'normal'
  },
  medium: {
    fontSize: '1.8rem',
    lineHeight: '2.4rem',
    fontWeight: 'normal'
  },
  small: {
    fontSize: '1.6rem',
    lineHeight: '2.2rem',
    fontWeight: 'normal'
  },
  xsmall: {
    fontSize: '1.4rem',
    lineHeight: '2.0rem',
    fontWeight: 'normal'
  }
};
exports.bodySize = bodySize;
var pageTitleSize = {
  xlarge: {
    fontSize: '8rem',
    lineHeight: '8.8rem'
  },
  large: {
    fontSize: '3.2rem',
    lineHeight: '4rem',
    fontWeight: 'bold'
  },
  medium: {
    fontSize: '2.8rem',
    lineHeight: '3.6rem',
    fontWeight: 'bold'
  },
  small: {
    fontSize: ['2rem', null, '2.4rem'],
    lineHeight: ['2.6rem', null, '3.1rem'],
    fontWeight: 'bold'
  },
  xsmall: {
    fontSize: '2rem',
    lineHeight: '2.8rem',
    fontWeight: 'bold'
  },
  xxsmall: {
    fontSize: '1.6rem',
    lineHeight: '2.0rem',
    fontWeight: 'bold'
  }
};
exports.pageTitleSize = pageTitleSize;
var heroTitleSize = {
  large: {
    fontSize: ['3rem', null, '4rem', '5.6rem'],
    lineHeight: ['3.6rem', null, '4.8rem', '6.4rem'],
    fontWeight: 'bold'
  },
  medium: {
    fontSize: ['3rem', null, '3.6rem', '4.8rem'],
    lineHeight: ['3.6rem', null, '4rem', '5.6rem'],
    fontWeight: 'bold'
  },
  small: {
    fontSize: '4rem',
    lineHeight: '4.8rem',
    fontWeight: 'bold'
  },
  xsmall: {
    fontSize: '3.2rem',
    lineHeight: '4rem',
    fontWeight: 'bold'
  }
};
exports.heroTitleSize = heroTitleSize;

var withHeaderSlash = function withHeaderSlash(brand) {
  return {
    padding: "0 0 0 ".concat(_space.default.xsmall),
    '&::before': {
      content: '"/"',
      position: 'relative',
      top: '0',
      left: "-".concat(_space.default.xsmall),
      color: _colors.default[brand].secondary,
      fontWeight: 'bold'
    }
  };
};

var textStyles = {
  // --- HORIZON --- //
  horizon: {
    // body
    globalText: {
      mobile: {
        fontSize: '1.4rem',
        lineHeight: '2.1rem',
        margin: 'auto'
      },
      tablet: {
        fontSize: fluidFont(1.4, 1.6),
        lineHeight: fluidFont(2.4, 2.4)
      },
      desktop: {
        fontSize: '1.6rem',
        lineHeight: '2.4rem'
      }
    },
    // p
    bodyText: {
      mobile: {
        fontSize: '1.6rem',
        lineHeight: '2.4rem',
        marginTop: '0',
        marginBottom: '2.4rem'
      },
      tablet: {
        fontSize: fluidFont(1.6, 1.8),
        lineHeight: fluidFont(2.4, 2.7),
        marginTop: 0,
        marginBottom: fluidFont(2.4, 2.7)
      },
      desktop: {
        fontSize: '1.8rem',
        lineHeight: '2.7rem',
        marginTop: '0',
        marginBottom: '2.7rem'
      }
    },
    headingText: {
      // h1
      primary: {
        mobile: {
          fontSize: '5.4rem',
          lineHeight: '7.2rem',
          marginTop: '2.4rem',
          marginBottom: '4.8rem',
          padding: 0
        },
        tablet: {
          fontSize: fluidFont(5.4, 6.1),
          lineHeight: fluidFont(7.2, 8.1),
          marginTop: fluidFont(2.4, 2.7),
          marginBottom: fluidFont(4.8, 5.4)
        },
        desktop: {
          fontSize: '6.1rem',
          lineHeight: '8.1rem',
          marginTop: '2.7rem',
          marginBottom: '5.4rem'
        }
      },
      // h2
      secondary: {
        mobile: {
          fontSize: '3.6rem',
          lineHeight: '4.8rem',
          marginTop: '2.4rem',
          marginBottom: '4.8rem',
          padding: 0
        },
        tablet: {
          fontSize: fluidFont(3.6, 4.1),
          lineHeight: fluidFont(4.8, 5.4),
          marginTop: fluidFont(2.4, 2.7),
          marginBottom: fluidFont(4.8, 5.4)
        },
        desktop: {
          fontSize: '4.1rem',
          lineHeight: '5.4rem',
          marginTop: '2.7rem',
          marginBottom: '5.4rem'
        }
      },
      // h3
      tertiary: {
        mobile: {
          fontSize: '2.4rem',
          lineHeight: '2.4rem',
          marginTop: '2.4rem',
          marginBottom: '2.4rem',
          padding: 0
        },
        tablet: {
          fontSize: fluidFont(2.4, 2.7),
          lineHeight: fluidFont(2.4, 2.7),
          marginTop: fluidFont(2.4, 2.7),
          marginBottom: fluidFont(2.4, 2.7)
        },
        desktop: {
          fontSize: '2.7rem',
          lineHeight: '2.7rem',
          marginTop: '2.7rem',
          marginBottom: '2.7rem'
        }
      },
      // h4
      quaternary: {
        mobile: {
          fontSize: '1.6rem',
          lineHeight: '2.4rem',
          marginTop: '2.4rem',
          marginBottom: '2.4rem',
          padding: 0
        },
        tablet: {
          fontSize: fluidFont(1.6, 1.8),
          lineHeight: fluidFont(2.4, 2.7),
          marginTop: fluidFont(2.4, 2.7),
          marginBottom: fluidFont(2.4, 2.7)
        },
        desktop: {
          fontSize: '2rem',
          lineHeight: '2.7rem',
          marginTop: '2.7rem',
          marginBottom: '2.7rem'
        }
      }
    }
  },
  // --- CANNES LIONS --- //
  cannesLions: {// Here you can overwrite the above default Horizon settings
  },
  // --- LIONS LIVE --- //
  lionsLive: {// Here you can overwrite the above default Horizon settings
  },
  // --- MONEY 2020 --- //
  money2020: {
    // Here you can overwrite the above default Horizon settings
    headingText: {
      secondary: {
        mobile: _objectSpread({}, withHeaderSlash('money2020'))
      },
      tertiary: {
        mobile: _objectSpread({}, withHeaderSlash('money2020'))
      },
      quaternary: {
        mobile: _objectSpread({}, withHeaderSlash('money2020'))
      }
    }
  },
  // --- SPIKES ASIA --- //
  spikes: {// Here you can overwrite the above default Horizon settings
  },
  // --- ASCENTIAL --- //
  ascential: {// Here you can overwrite the above default Horizon settings
  },
  // --- LIONS CREATIVITY --- //
  lionsCreativity: {
    headingText: {
      // h1
      primary: {
        mobile: {
          fontSize: '6rem',
          lineHeight: '7.2rem',
          marginTop: '2.4rem',
          marginBottom: '4.8rem',
          padding: 0
        },
        tablet: {
          fontSize: fluidFont(5.4, 6.1),
          lineHeight: fluidFont(7.2, 8.1),
          marginTop: fluidFont(2.4, 2.7),
          marginBottom: fluidFont(4.8, 5.4)
        },
        desktop: {
          fontSize: '10rem',
          lineHeight: '8.1rem',
          marginTop: '2.7rem',
          marginBottom: '5.4rem'
        }
      }
    }
  }
};
exports.textStyles = textStyles;
var _default = textStyles;
exports.default = _default;